import { useRouter } from 'next/router';

export const useNewsletter = (): boolean => {
  const router = useRouter();

  const useNewsletter = router.locale === 'nl-NL';

  return useNewsletter;
};
